import { Icon } from '@/shared/types/icon';

export const DeepgramIcon = ({ size = 16, className = '' }: Icon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        fill="#000"
        fillRule="evenodd"
        d="M10.85 4.564a4.87 4.87 0 0 1 1.41 3.513v-.002c-.04 2.66-2.279 4.825-4.987 4.825H3.467a.081.081 0 0 1-.057-.139l1.852-1.86a.16.16 0 0 1 .116-.05h1.93c1.553 0 2.855-1.24 2.9-2.764a2.83 2.83 0 0 0-.805-2.071 2.83 2.83 0 0 0-2.047-.866H5.391v3.172a.05.05 0 0 1-.049.049H3.389a.05.05 0 0 1-.05-.05V3.15c0-.028.022-.049.05-.049h3.967c1.322 0 2.563.52 3.493 1.464"
        clipRule="evenodd"
      />
    </svg>
  );
};
